import { gql } from '@apollo/client';

import { CUSTOM_ENTITY_TYPES } from 'app/Config/EntityTypes/gql';
import {
  CustomEntityTypesQuery as CustomEntityTypes,
  EntityCriticalityConfigListQuery as EntityCriticalityConfigList,
  InventoryLookupOperationQuery as InventoryLookupOperation,
} from 'core/graphql';
import { useQuery } from 'shared/hooks';

export const ENTITY_LIST_FRAGMENT = gql`
  fragment EntityListFragment on EntityInterface {
    activityScore
    criticality
    entityType
    entityTypeName
    id
    isWhitelisted
    lastSeen
    recentSignalSeverity
    reputation
    reputationSources
    sensorZone
    suppressListsObj {
      id
      name
    }
    tags
    value
  }
`;

export const ENTITY_LIST_QUERY_OPERATION = gql`
  query EntityListQueryOperation(
    $offset: Int
    $limit: Int
    $q: String
    $sort: EntitySortableField!
    $sortDir: SortDir!
  ) {
    insightConfig {
      threshold
    }
    entities(
      offset: $offset
      limit: $limit
      q: $q
      sort: [{ field: $sort, direction: $sortDir }]
    ) {
      total
      hasNextPage
      objects {
        ...EntityListFragment
      }
    }
  }
  ${ENTITY_LIST_FRAGMENT}
`;

export const ENTITY_DETAILS_AUDIT_LOG_QUERY = gql`
  fragment EntityDetailsAuditLogFragment on EntityAuditLog {
    id
    action
    timestamp
    suppressedComment
    metaJson
    user {
      id
      email
      displayName
    }
  }
  query EntityDetailsAuditLogQueryOperation($id: ID!) {
    entity(id: $id) {
      ... on EntityInterface {
        id
        auditLog {
          ...EntityDetailsAuditLogFragment
        }
      }
    }
  }
`;

export const ENTITY_CRITICALITY_CONFIG_LIST_QUERY = gql`
  fragment EntityCriticalityConfigListFragment on EntityCriticalityConfig {
    id
    name
    severityExpression
  }
  query EntityCriticalityConfigList {
    entityCriticalityConfigs {
      total
      objects {
        ...EntityCriticalityConfigListFragment
      }
    }
  }
`;

export const useEntityCriticalities = () =>
  useQuery<EntityCriticalityConfigList>(ENTITY_CRITICALITY_CONFIG_LIST_QUERY);

export const useCustomEntityTypes = () => {
  return useQuery<CustomEntityTypes>(CUSTOM_ENTITY_TYPES);
};

export const INVENTORY_LOOKUP_TABLE_QUERY = gql`
  query InventoryLookupOperation {
    inventoryLookupTableSources
  }
`;

export const useInventoryLookupTable = () =>
  useQuery<InventoryLookupOperation>(INVENTORY_LOOKUP_TABLE_QUERY);
